import { Button } from "./components/Button";

function AppIcon() {
  return (
    <svg
      viewBox="0 0 640 220"
      className="w-full"
      fill="none"
      role="img"
      aria-label="Kin signature logo"
    >
      <defs>
        <linearGradient
          id="kin-icon-wash"
          x1="62"
          y1="32"
          x2="158"
          y2="170"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#F4F3F0" />
          <stop offset="1" stopColor="#E7E6E3" />
        </linearGradient>
        <linearGradient
          id="kin-icon-line"
          x1="78"
          y1="34"
          x2="149"
          y2="158"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#2A332D" />
          <stop offset="1" stopColor="var(--color-kin-green-soft)" />
        </linearGradient>
      </defs>

      <rect x="42" y="26" width="136" height="136" rx="38" fill="url(#kin-icon-wash)" />
      <rect
        x="42"
        y="26"
        width="136"
        height="136"
        rx="38"
        stroke="var(--color-kin-black)"
        strokeOpacity="0.12"
        strokeWidth="2.5"
      />

      <path
        d="M82 56V132M82 95h34M116 95l32-39M116 95l35 41"
        stroke="url(#kin-icon-line)"
        strokeWidth="9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M111 56c18 0 34 14 36 32"
        stroke="var(--color-kin-lavender)"
        strokeOpacity="0.34"
        strokeWidth="4.5"
        strokeLinecap="round"
      />
      <circle cx="148" cy="89" r="5.5" fill="var(--color-kin-orange)" />

      <text
        x="224"
        y="112"
        fontFamily="'Cormorant Garamond', Georgia, serif"
        fontSize="92"
        fontWeight="700"
        fill="var(--color-kin-black)"
      >
        Kin
      </text>
      <text
        x="228"
        y="144"
        fontFamily="'Manrope', system-ui, sans-serif"
        fontSize="18"
        fontWeight="600"
        fill="var(--color-kin-muted)"
        letterSpacing="0.08em"
      >
        PERSONAL HEALTH INTELLIGENCE
      </text>
    </svg>
  );
}

export default function LogoPage() {
  return (
    <div className="min-h-screen bg-kin-sunrise px-6 py-10 sm:px-8 sm:py-12">
      <div className="pointer-events-none fixed inset-0 -z-10 bg-kin-sunrise animate-drift" />

      <div className="mx-auto max-w-6xl">
        <header className="kin-surface-strong kin-surface-clouds rounded-3xl p-6 sm:p-8">
          <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
            <div>
              <p className="text-xs font-semibold tracking-[0.22em] uppercase text-kin-muted">
                Kin Identity
              </p>
              <h1 className="mt-3 font-serif text-5xl font-bold leading-none text-kin-black sm:text-6xl">
                /logo
              </h1>
              <p className="mt-3 max-w-3xl text-sm leading-relaxed text-kin-body/90">
                The Kin mark. A sculpted K in a soft vessel, paired with a refined wordmark. The
                orbit accent hints at ongoing care cycles while the warm signal dot introduces human
                energy.
              </p>
            </div>
            <div className="flex items-center gap-2">
              <a href="/private/design/mobile">
                <Button variant="secondary">Mobile</Button>
              </a>
              <a href="/private/design">
                <Button variant="secondary">Brandbook</Button>
              </a>
            </div>
          </div>
        </header>

        <section className="mt-8 pb-6">
          <div className="kin-surface-strong kin-surface-clouds rounded-3xl p-6 sm:p-8">
            <div className="rounded-2xl border border-kin-olive/12 bg-kin-white/86 p-5 sm:p-7">
              <AppIcon />
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
